import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export default class Dictionaries {
  public UserVerificationRequirement = {
    REQUIRED: 'required',
    PREFERRED: 'preferred',
    DISCOURAGED: 'discouraged',
  };

  public AuthenticatorAttachment = {
    PLATFORM: 'platform',
    CROSS_PLATFORM: 'cross-platform',
  };

  public AttestationConveyancePreference = {
    NONE: 'none',
    DIRECT: 'direct',
    INDIRECT: 'indirect',
  };

  public PublicKeyCredentialType = {
    PUBLIC_KEY: 'public-key',
  };

  public AuthenticatorTransport = {
    USB: 'usb',
    NFC: 'nfc',
    BLE: 'ble',
    INTERNAL: 'internal',
  };
}
